import { render, staticRenderFns } from "./NestedDraggable.vue?vue&type=template&id=31d6d64e"
import script from "./NestedDraggable.vue?vue&type=script&lang=js"
export * from "./NestedDraggable.vue?vue&type=script&lang=js"
import style0 from "./NestedDraggable.vue?vue&type=style&index=0&id=31d6d64e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports